import { render, staticRenderFns } from "./testResult.vue?vue&type=template&id=2d43b79b&scoped=true"
import script from "./testResult.vue?vue&type=script&lang=js"
export * from "./testResult.vue?vue&type=script&lang=js"
import style0 from "./testResult.vue?vue&type=style&index=0&id=2d43b79b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d43b79b",
  null
  
)

export default component.exports